"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBadgeList = getBadgeList;
var _request = _interopRequireDefault(require("@/utils/request"));
function getBadgeList(token, setting) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: `/badges/?page=${setting.page}&limit=${setting.limit}&sort=${setting.sorting}`,
    baseURL: process.env.VUE_APP_BASE_API,
    method: 'get',
    headers
  });
}